<mat-card>
	<mat-card-header>
		<mat-card-title>
			Demographics
		</mat-card-title>
	</mat-card-header>

	<mat-card-content *ngIf="studentId">
		<view-child-demographic-termination [studentId]="studentId"
			[studentHelperNumber]="studentHelperNumber"></view-child-demographic-termination>

		<view-child-demographic-general [studentId]="studentId"
			[studentHelperNumber]="studentHelperNumber"></view-child-demographic-general>

		<mat-divider class="margin-vertical-sm"></mat-divider>

		<view-child-eligibility-checkboxes [studentId]="studentId"
			[showMatDivider]="false"></view-child-eligibility-checkboxes>

		<mat-divider class="margin-vertical-sm"></mat-divider>

		<view-child-demographic-parents [studentId]="studentId"></view-child-demographic-parents>

		<mat-divider class="margin-vertical-sm"></mat-divider>

		<view-child-demographic-identifiers [studentId]="studentId"
			[studentHelperNumber]="studentHelperNumber"></view-child-demographic-identifiers>

	</mat-card-content>
</mat-card>